export { ConfigProvider, ConfigConsumer, useConfig } from './context';
export { withConfig } from './withConfig';

export type ConfigProps = import('./withConfig').ConfigProps;
